import { useContext } from 'react'

import { useFeatureSwitch } from '@marketplace-web/feature-flags/feature-switches-data'
import { useSession } from '@marketplace-web/shared/session-data'
import { logBrazeMessage } from '@marketplace-web/braze/braze-data'

import BrazeContext from '../containers/BrazeProvider/BrazeContext'

export const useGetUserExternalId = () => {
  const fetchExternalIdEnabled = useFeatureSwitch('kk_migrate_external_id_retrieval_web')
  const brazeServiceExternalId = useContext(BrazeContext).userExternalId
  const { user } = useSession()
  const userDtoExternalId = user?.external_id

  const userExternalId = fetchExternalIdEnabled ? brazeServiceExternalId : userDtoExternalId

  if (user && !userExternalId) {
    // Temporary logging for monitoring new logic
    logBrazeMessage(
      `ExternalID FS: ${fetchExternalIdEnabled ? 'ON' : 'OFF'} Braze externalId is empty`,
    )
  }

  return userExternalId
}
